export default "../css/11c47748414ab8a89db0d498b1086587.ttf";